@if (field) {
  <div class="select-search-field query-operator">
      <mat-form-field class="select-inline no-label fill">
        <mat-select [(ngModel)]="rule.operator" (ngModelChange)="setSelectedOperator($event)">
          @for (value of operatorMap[field.type]; track value) {
            <mat-option [value]="value" [matTooltip]="operatorDesc[value]"
              matTooltipPosition="right">{{operatorDesc[value]}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
  </div>
}
